import { useFormContext } from "react-hook-form"

import type { ProductAddonWithImages } from "pages/products/[slug]"

const AddonSummaryItem: React.FC<{ addon: ProductAddonWithImages }> = ({
  addon
}) => {
  const rhf = useFormContext()

  return (
    <div key={`globalAddon${addon.id}`}>
      <p className="font-bold my-0">{addon.title}:</p>
      <p className="mt-0 font-bold text-sm">
        {
          // SINGLE type should display YES if the quantity is 1
          addon.type === "SINGLE"
            ? rhf.watch(`addons.${addon.id}.quantity`) === 1
              ? "Yes"
              : "No"
            : // MULTIPLE type should display the quantity. If the quantity is NaN (empty), display 0
            addon.type === "MULTIPLE"
            ? rhf.watch(`addons.${addon.id}.quantity`) || 0
            : // TEMPLATE type should output the title. If the title is an array join it, if it's a string just display it
            addon.type === "TEMPLATE"
            ? Array.isArray(rhf.watch(`addons.${addon.id}.title`))
              ? rhf.watch(`addons.${addon.id}.title`).join(", ")
              : rhf.watch(`addons.${addon.id}.title`)
            : null
        }
      </p>
    </div>
  )
}

export default AddonSummaryItem
